export const FEATURE_NAME = 'manage-cards';
